// import PostApp from './PostApp';
// hM8aa50qhCdSXzhCHxt2
// oc3seMNDCGBWexpAxJlM

const ApiId = 'hM8aa50qhCdSXzhCHxt2';
const url = `https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi/apps/${ApiId}/books`;

export default url;
